<template>
  <div class="buttons" :class="{
    open: Open,
    bottom: aplicacion.view.Live == '3d',
    pano: aplicacion.coleccionSel.pano,
  }">
    <div v-for="(Button, ButtonIndex) in Buttons" class="buttons__item" @click="SetContent(Button)" :class="{
      noMontaje: Button.cod == 'montaje' && !aplicacion.montajeExists(),
      open: Button.cod == 'detalles' && Detalles,
      active:
        Content == Button.cod ||
        (Button.cod == 'zoom' && Zoom) ||
        (Button.cod == 'comparador' && Comparador) ||
        (Button.cod == 'caracteristicas' && Content == 'grupos') ||
        (Button.cod == 'detalles' && Detalles),
      hidden:
        ((Button.cod == 'resumen' ||
          Button.cod == 'comparador' ||
          Button.cod == 'zoom') &&
          SetEsError(
            aplicacion.coleccionSel.sideSel.Live.EsError(
              aplicacion.coleccionSel.sideSel.Live.perfil
            )
          )) ||
        (aplicacion.view.Live == '3d' &&
          (Button.cod == 'caracteristicas' ||
            Button.cod == 'resumen' ||
            Button.cod == 'favorites' ||
            Button.cod == 'zoom' ||
            Button.cod == 'comparador')),
      grupo: Button.cod == 'caracteristicas' && Content == 'caracteristicas',
      detalles: Button.cod == 'detalles',
    }">
      <div v-if="Button.cod == 'detalles'" class="buttons__item__options">
        <div class="buttons__item__options__item" :class="{
          disabled:
            aplicacion.ficha == null ||
            aplicacion.ficha == undefined ||
            aplicacion.ficha == '',
        }" @click="
          SetButtonOption({
            cod: 'Pdf',
            url: aplicacion.ficha,
          })
          ">
          <div class="buttons__item__options__item__miniatura">
            <img src="@/assets/Images/Global/PDF.svg" alt="" class="buttons__item__options__item__miniatura__image" />
          </div>
          <p class="buttons__item__options__item__text">
            {{
              aplicacion.languageSel == "es"
                ? "Ficha técnica"
                : aplicacion.languageSel == "en"
                  ? "Technical sheet"
                  : aplicacion.languageSel == "fr"
                    ? "Fiche technique"
                    : aplicacion.languageSel == "de"
                      ? "Technisches Datenblatt"
                      : aplicacion.languageSel == "it"
                        ? "Scheda tecnica"
                        : "Ficha técnica"
            }}
          </p>
        </div>
        <div class="buttons__item__options__item" :class="{
          disabled:
            aplicacion.manual == null ||
            aplicacion.manual == undefined ||
            aplicacion.manual == '',
        }" @click="
          SetButtonOption({
            cod: 'Pdf',
            url: aplicacion.manual,
          })
          ">
          <div class="buttons__item__options__item__miniatura">
            <img src="@/assets/Images/Global/Info.svg" alt="" class="buttons__item__options__item__miniatura__image" />
          </div>
          <p class="buttons__item__options__item__text">
            {{
              aplicacion.languageSel == "es"
                ? "Manual montaje"
                : aplicacion.languageSel == "en"
                  ? "Assembly manual"
                  : aplicacion.languageSel == "fr"
                    ? "Manuel de montage"
                    : aplicacion.languageSel == "de"
                      ? "Montageanleitung"
                      : aplicacion.languageSel == "it"
                        ? "Manuale di montaggio"
                        : "Manual de montagem"
            }}
          </p>
        </div>
        <div class="buttons__item__options__item" :class="{
          disabled:
            aplicacion.video == null ||
            aplicacion.video == undefined ||
            aplicacion.video == '',
        }" @click="
          SetButtonOption({
            cod: 'Video',
            url: aplicacion.video,
          })
          ">
          <div class="buttons__item__options__item__miniatura">
            <img src="@/assets/Images/Global/YouTube.svg" alt=""
              class="buttons__item__options__item__miniatura__image" />
          </div>
          <p class="buttons__item__options__item__text">
            {{
              aplicacion.languageSel == "es"
                ? "Vídeo montaje"
                : aplicacion.languageSel == "en"
                  ? "Assembly video"
                  : aplicacion.languageSel == "fr"
                    ? "Vidéo de montage"
                    : aplicacion.languageSel == "de"
                      ? "Montagevideo"
                      : aplicacion.languageSel == "it"
                        ? "Video di montaggio"
                        : "Vídeo de montagem"
            }}
          </p>
        </div>
      </div>
      <div v-if="Button.cod != 'view' && Button.cod != 'detalles'" class="buttons__item__miniatura" :style="Button.cod == 'download'
        ? 'position:relative; display: flex;    flex-direction: row;    justify-content: center;    align-items: center;'
        : ''
        ">
        <img v-if="Button.cod == 'download'" :src="require('@/assets/Images/Global/' + 'Loader.svg')" alt=""
          class="buttons__item__miniatura__image" :class="{
            hidden: !pdf,
          }" id="loader" :style="DarkMode.Live
            ? 'position:absolute;filter: invert(1) !important'
            : 'position:absolute;filter: invert(0) !important'
            " />
        <img :src="require('@/assets/Images/' +
          (Button.cod == 'zoom'
            ? Zoom
              ? 'Global/Subtract.svg'
              : 'Global/Add.svg'
            : Button.miniatura))
          " alt="" class="buttons__item__miniatura__image" :class="{
            hidden: Button.cod == 'download' && pdf,
          }" />
      </div>
      <div v-else-if="Button.cod == 'view'" class="buttons__item__miniatura">
        <img @load="ResolveImage($event)" :src="require('@/assets/Images/' +
          Button.miniatura[aplicacion.view.Delay == '2d' ? 1 : 0])
          " alt="" class="buttons__item__miniatura__image" />
      </div>
      <div v-if="Button.cod == 'detalles'" class="buttons__item__miniatura">
        <div class="buttons__item__miniatura__image"></div>
      </div>
      <div class="buttons__item__grupo">
        <p class="buttons__item__grupo__text">
          {{ aplicacion.grupoSel.Live.GetLiteral(aplicacion.languageSel) }}
        </p>
        <img src="@/assets/Images/Global/Expand.svg" alt="" class="buttons__item__grupo__expand" />
      </div>
      <p v-if="Button.cod != 'view'" class="buttons__item__text">
        {{
          Button.literales[
            Button.literales.findIndex(
              (Literal) => Literal.codIdioma == Language
            )
          ].texto
        }}
      </p>
      <div v-else class="buttons__item__text">
        <p>
          {{
            Button.literales[
              Button.literales.findIndex(
                (Literal) => Literal.codIdioma == Language
              )
            ].texto[aplicacion.view.Delay == "2d" ? 0 : 1]
          }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Buttons",
  data() {
    return {
      Detalles: false,
      Stored: {
        Comparador: false,
        Zoom: false,
      },
    };
  },
  props: {
    pdf: Boolean,
    aplicacion: Object,
    Language: String,
    Open: Boolean,
    Buttons: Array,
    Content: String,
    Comparador: Boolean,
    Zoom: Boolean,
    Hotspots: Object,
    Version: String,
    DarkMode: Object,
  },
  methods: {
    SetButtonOption(Object) {
      if (window.innerWidth < 950 || window.innerHeight < 600) {
        var url = Object.url;
        var a = document.createElement("a");
        a.href = url;
        a.target = "_blank";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      } else {
        this.$root.$emit("Modal", "Option", Object);
      }
    },
    ResolveImage(e) {
      var element;
      if (e.target == null || e.target == undefined) {
        element = e.path[0];
      } else {
        element = e.target;
      }
      element.style.opacity = 1;
    },
    SetEsError(Status) {
      if (Status) {
        if (this.Comparador) {
          this.$emit("Comparador", false);
          this.Stored.Comparador = true;
        }
        if (this.Zoom) {
          var Zoom;
          if (window.location.href.includes("8081")) {
            Zoom = document.getElementsByClassName("buttons__item")[0];
          } else {
            Zoom = document
              .querySelector("c-selector")
              .shadowRoot.querySelector(".buttons__item");
          }
          this.Stored.Zoom = true;
          Zoom.click();
        }
      } else {
        if (this.Stored.Comparador) {
          this.$emit("Comparador", true);
          this.Stored.Comparador = false;
        }
        if (this.Stored.Zoom) {
          var Zoom;
          if (window.location.href.includes("8081")) {
            Zoom = document.getElementsByClassName("buttons__item")[0];
          } else {
            Zoom = document
              .querySelector("c-selector")
              .shadowRoot.querySelector(".buttons__item");
          }
          this.Stored.Zoom = false;
          Zoom.click();
        }
      }
      return Status;
    },
    SetContent(Object) {
      if (Object.cod == "zoom") {
        this.$emit("Zoom", !this.Zoom);
        this.$emit("Comparador", false);
        if (this.Zoom == false) {
          this.$emit("Hotspots", false);
        } else {
          this.$emit("Hotspots", true);
        }
      } else if (Object.cod == "montaje") {
        this.$emit("Content", "caracteristicas");
        this.aplicacion.grupoSel.Live =
          this.aplicacion.coleccionSel.sideSel.Live.GetGrupo("MONTAJE");
        setTimeout(() => {
          this.aplicacion.grupoSel.Delay =
            this.aplicacion.coleccionSel.sideSel.Live.GetGrupo("MONTAJE");
        }, 350);
        this.$emit("Open", true);
      } else if (Object.cod == "download") {
        this.$emit("setPdf", true);
      } else if (Object.cod == "comparador") {
        this.$emit("Comparador", !this.Comparador);
        this.$emit("Zoom", false);
      } else if (Object.cod == "detalles") {
        if (this.Version == "4000") {
        } else {
          this.Detalles = !this.Detalles;
        }
      } else if (Object.cod == "view") {
        this.$emit("Content", "");
        this.$emit("Open", false);
        this.$emit("Zoom", false);
        this.$emit("Comparador", false);
        setTimeout(
          () => {
            this.$emit("View", this.aplicacion.view.Live == "2d" ? "3d" : "2d");
          },
          this.aplicacion.view.Live == "2d" && this.Open ? 350 : 0
        );
      } else if (Object.cod == "cerrar") {
        this.$emit("Content", "");
        this.$emit("Open", false);
      } else {
        if (
          window.innerHeight < 650 ||
          (window.innerWidth < 950 && window.innerHeight > 650)
        ) {
          if (Object.cod == "caracteristicas") {
            if (this.Content == "grupos") {
              this.$emit("Content", "");
              this.$emit("Open", false);
            } else {
              this.$emit("Content", "grupos");
              this.$emit("Open", true);
            }
          } else {
            if (this.Content != Object.cod) {
              this.$emit("Content", Object.cod);
              this.$emit("Open", true);
            } else {
              this.$emit("Content", "");
              this.$emit("Open", false);
            }
          }
        } else {
          if (this.Content != Object.cod) {
            this.$emit("Content", Object.cod);
            this.$emit("Open", true);
            if (Object.cod == "caracteristicas") {
              setTimeout(() => {
                var Menu;
                if (window.location.href.includes("8081")) {
                  Menu = document.getElementsByClassName(
                    "menu__caracteristicas__campos"
                  )[0];
                } else {
                  Menu = document
                    .querySelector("c-selector")
                    .shadowRoot.querySelector(".menu__caracteristicas__campos");
                }
                var CamposError = [];
                if (
                  this.aplicacion.grupoSel.Live.EsError(
                    this.aplicacion.coleccionSel.sideSel.Live.perfil
                  )
                ) {
                  var Campos;
                  if (window.location.href.includes("8081")) {
                    Campos = document.getElementsByClassName(
                      "menu__caracteristicas__campos"
                    )[0].children;
                  } else {
                    Campos = document
                      .querySelector("c-selector")
                      .shadowRoot.querySelector(
                        ".menu__caracteristicas__campos"
                      ).children;
                  }
                  for (const Campo of Campos) {
                    if (Campo.getAttribute("error")) {
                      CamposError.push(Campo);
                    }
                  }
                  if (Menu.scrollHeight > Menu.clientHeight) {
                    Menu.scrollTop = CamposError[0].offsetTop;
                    CamposError.forEach((CampoError) => {
                      setTimeout(() => {
                        CampoError.classList.add("pop");
                        setTimeout(() => {
                          CampoError.classList.remove("pop");
                        }, 350);
                      }, 150);
                    });
                  } else {
                    CamposError.forEach((CampoError) => {
                      setTimeout(() => {
                        CampoError.classList.add("pop");
                        setTimeout(() => {
                          CampoError.classList.remove("pop");
                        }, 350);
                      }, 150);
                    });
                  }
                }
              }, 350);
            }
          } else {
            this.$emit("Content", "");
            this.$emit("Open", false);
          }
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.buttons {
  z-index: 10001;
  position: absolute;
  bottom: 18dvh;
  right: 0;
  -webkit-transition: right 0.35s ease-in-out;
  -moz-transition: right 0.35s ease-in-out;
  -ms-transition: right 0.35s ease-in-out;
  -o-transition: right 0.35s ease-in-out;
  transition: right 0.35s ease-in-out;

  &__item {
    opacity: 1;
    cursor: pointer;
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    align-content: center;
    -webkit-transition: opacity 0.35s ease-in-out;
    -moz-transition: opacity 0.35s ease-in-out;
    -ms-transition: opacity 0.35s ease-in-out;
    -o-transition: opacity 0.35s ease-in-out;
    transition: opacity 0.35s ease-in-out;

    &__miniatura {
      opacity: 1;
      width: 40px;
      height: 40px;
      padding: 8px;
      background-color: white;
      -webkit-transition: background-color 0.35s ease-in-out,
        opacity 0.35s ease-in-out;
      -moz-transition: background-color 0.35s ease-in-out,
        opacity 0.35s ease-in-out;
      -ms-transition: background-color 0.35s ease-in-out,
        opacity 0.35s ease-in-out;
      -o-transition: background-color 0.35s ease-in-out,
        opacity 0.35s ease-in-out;
      transition: background-color 0.35s ease-in-out, opacity 0.35s ease-in-out;

      & #loader {
        opacity: 1;
        pointer-events: none;
        -webkit-transition: filter 0.35s ease-in-out, opacity 0.35s ease-in-out;
        -moz-transition: filter 0.35s ease-in-out, opacity 0.35s ease-in-out;
        -ms-transition: filter 0.35s ease-in-out, opacity 0.35s ease-in-out;
        -o-transition: filter 0.35s ease-in-out, opacity 0.35s ease-in-out;
        transition: filter 0.35s ease-in-out, opacity 0.35s ease-in-out;
      }

      &__image {
        opacity: 1;
        filter: invert(0%);
        width: 100%;
        height: 100%;
        object-fit: cover;
        -webkit-transition: filter 0.35s ease-in-out, opacity 0.35s ease-in-out;
        -moz-transition: filter 0.35s ease-in-out, opacity 0.35s ease-in-out;
        -ms-transition: filter 0.35s ease-in-out, opacity 0.35s ease-in-out;
        -o-transition: filter 0.35s ease-in-out, opacity 0.35s ease-in-out;
        transition: filter 0.35s ease-in-out, opacity 0.35s ease-in-out;
      }
    }

    &__grupo {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      opacity: 0;
      pointer-events: none;
      position: absolute;
      -webkit-transition: opacity 0.35s ease-in-out;
      -moz-transition: opacity 0.35s ease-in-out;
      -ms-transition: opacity 0.35s ease-in-out;
      -o-transition: opacity 0.35s ease-in-out;
      transition: opacity 0.35s ease-in-out;

      &__text {
        font-size: 12px;
        line-height: 12px;
        color: white;
      }

      &__expand {
        filter: invert(100%);
        height: 20px;
      }
    }

    &__text {
      filter: invert(0%);
      opacity: 0;
      pointer-events: none;
      position: absolute;
      right: 50px;
      background-color: black;
      color: white;
      font-size: 10px;
      line-height: 10px;
      padding: 4px 14px;
      white-space: nowrap;
      -webkit-transition: opacity 0.35s ease-in-out, filter 0.35s ease-in-out;
      -moz-transition: opacity 0.35s ease-in-out, filter 0.35s ease-in-out;
      -ms-transition: opacity 0.35s ease-in-out, filter 0.35s ease-in-out;
      -o-transition: opacity 0.35s ease-in-out, filter 0.35s ease-in-out;
      transition: opacity 0.35s ease-in-out, filter 0.35s ease-in-out;

      & p {
        opacity: 1;
        -webkit-transition: opacity 0.35s ease-in-out;
        -moz-transition: opacity 0.35s ease-in-out;
        -ms-transition: opacity 0.35s ease-in-out;
        -o-transition: opacity 0.35s ease-in-out;
        transition: opacity 0.35s ease-in-out;
      }
    }

    &:hover {
      & .buttons__item {
        &__text {
          opacity: 1;
          -webkit-transition: opacity 0.35s ease-in-out;
          -moz-transition: opacity 0.35s ease-in-out;
          -ms-transition: opacity 0.35s ease-in-out;
          -o-transition: opacity 0.35s ease-in-out;
          transition: opacity 0.35s ease-in-out;
        }
      }
    }

    &:nth-child(1) {
      margin-bottom: 40px;
      border-radius: 5px 0px 0px 5px;

      & .buttons__item {
        &__miniatura {
          border-radius: 5px 0px 0px 5px;
        }
      }
    }

    &:nth-child(2) {
      margin-bottom: 40px;
      border-radius: 5px 0px 0px 5px;

      & .buttons__item {
        &__miniatura {
          border-radius: 5px 0px 0px 5px;

          &__image {
            filter: invert(2) !important;
            -webkit-transition: filter 0.35s ease-in-out,
              opacity 0.35s ease-in-out;
            -moz-transition: filter 0.35s ease-in-out, opacity 0.35s ease-in-out;
            -ms-transition: filter 0.35s ease-in-out, opacity 0.35s ease-in-out;
            -o-transition: filter 0.35s ease-in-out, opacity 0.35s ease-in-out;
            transition: filter 0.35s ease-in-out, opacity 0.35s ease-in-out;
          }
        }
      }
    }

    &:nth-child(3) {
      position: fixed;
      left: 0;
      bottom: 18dvh;
      border-radius: 0px 5px 5px 0px;

      & .buttons__item {
        &__miniatura {
          border-radius: 0px 5px 5px 0px;
        }

        &__grupo {}

        &__text {
          right: revert;
          left: 50px;
        }
      }
    }

    &:nth-child(4) {
      border-radius: 5px 0px 0px 0px;

      & .buttons__item {
        &__miniatura {
          border-radius: 5px 0px 0px 0px;
        }
      }
    }

    &:nth-child(5) {
      border-radius: 0px 0px 0px 0px;

      & .buttons__item {
        &__miniatura {
          border-radius: 0px 0px 0px 0px;
        }
      }
    }

    &:nth-child(6) {
      margin-bottom: 40px;
      border-radius: 0px 0px 0px 5px;

      & .buttons__item {
        &__miniatura {
          border-radius: 0px 0px 0px 5px;
        }
      }
    }

    &:nth-child(7) {
      border-radius: 5px 0px 0px 0px;

      & .buttons__item {
        &__miniatura {
          border-radius: 5px 0px 0px 0px;
        }
      }
    }

    &:nth-child(8) {
      border-radius: 0px 0px 0px 5px;

      & .buttons__item {
        &__miniatura {
          border-radius: 0px 0px 0px 5px;
        }
      }
    }

    &:nth-child(9) {
      opacity: 0;
      pointer-events: none;
      width: 0px;
      height: 0px;
      margin-bottom: 40px;
      border-radius: 0px 0px 0px 5px;

      & .buttons__item {
        &__miniatura {
          background-color: black;
          border-radius: 0px 0px 0px 5px;
        }
      }
    }

    &:nth-child(10) {
      opacity: 0;
      pointer-events: none;
      border-radius: 5px 0px 0px 5px;

      & .buttons__item {
        &__miniatura {
          border-radius: 5px 0px 0px 5px;
        }
      }
    }

    &.noMontaje {
      display: none;
    }

    &.open {
      &.detalles {
        & .buttons__item {
          &__options {
            left: 0px;
            pointer-events: visible;
            -webkit-transition: left 0.35s ease-in-out !important;
            -moz-transition: left 0.35s ease-in-out !important;
            -ms-transition: left 0.35s ease-in-out !important;
            -o-transition: left 0.35s ease-in-out !important;
            transition: left 0.35s ease-in-out !important;

            &__item {
              &.disabled {
                opacity: 0.25;
                pointer-events: none;
              }
            }
          }

          &__text {
            opacity: 0;
          }
        }
      }
    }

    &.active {
      & .buttons__item {
        &__miniatura {
          background-color: black;
          -webkit-transition: background-color 0.35s ease-in-out,
            opacity 0.35s ease-in-out;
          -moz-transition: background-color 0.35s ease-in-out,
            opacity 0.35s ease-in-out;
          -ms-transition: background-color 0.35s ease-in-out,
            opacity 0.35s ease-in-out;
          -o-transition: background-color 0.35s ease-in-out,
            opacity 0.35s ease-in-out;
          transition: background-color 0.35s ease-in-out,
            opacity 0.35s ease-in-out;

          &__image {
            filter: invert(100%);
            -webkit-transition: filter 0.35s ease-in-out,
              opacity 0.35s ease-in-out;
            -moz-transition: filter 0.35s ease-in-out, opacity 0.35s ease-in-out;
            -ms-transition: filter 0.35s ease-in-out, opacity 0.35s ease-in-out;
            -o-transition: filter 0.35s ease-in-out, opacity 0.35s ease-in-out;
            transition: filter 0.35s ease-in-out, opacity 0.35s ease-in-out;
          }
        }
      }
    }

    &.hidden {
      pointer-events: none;

      & .buttons__item {
        &__miniatura {
          &__image {
            opacity: 0.3;
            -webkit-transition: filter 0.35s ease-in-out,
              opacity 0.35s ease-in-out;
            -moz-transition: filter 0.35s ease-in-out, opacity 0.35s ease-in-out;
            -ms-transition: filter 0.35s ease-in-out, opacity 0.35s ease-in-out;
            -o-transition: filter 0.35s ease-in-out, opacity 0.35s ease-in-out;
            transition: filter 0.35s ease-in-out, opacity 0.35s ease-in-out;
          }
        }
      }
    }

    &.detalles {
      & .buttons__item {
        position: relative;

        &__options {
          position: absolute;
          bottom: 100px;
          left: 0px;
          pointer-events: visible;
          -webkit-transition: left 0.35s ease-in-out !important;
          -moz-transition: left 0.35s ease-in-out !important;
          -ms-transition: left 0.35s ease-in-out !important;
          -o-transition: left 0.35s ease-in-out !important;
          transition: left 0.35s ease-in-out !important;

          &__item {
            opacity: 1;
            cursor: pointer;
            position: relative;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            align-content: center;
            -webkit-transition: opacity 0.35s ease-in-out;
            -moz-transition: opacity 0.35s ease-in-out;
            -ms-transition: opacity 0.35s ease-in-out;
            -o-transition: opacity 0.35s ease-in-out;
            transition: opacity 0.35s ease-in-out;

            &.disabled {
              opacity: 0.25;
              pointer-events: none;
            }

            &__miniatura {
              display: flex;
              justify-content: center;
              align-items: center;
              opacity: 1;
              width: 40px;
              height: 40px;
              padding: 8px;
              background-color: white;
              -webkit-transition: background-color 0.35s ease-in-out,
                opacity 0.35s ease-in-out;
              -moz-transition: background-color 0.35s ease-in-out,
                opacity 0.35s ease-in-out;
              -ms-transition: background-color 0.35s ease-in-out,
                opacity 0.35s ease-in-out;
              -o-transition: background-color 0.35s ease-in-out,
                opacity 0.35s ease-in-out;
              transition: background-color 0.35s ease-in-out,
                opacity 0.35s ease-in-out;

              &__image {
                opacity: 1;
                filter: invert(0%);
                width: 100%;
                height: 100%;
                max-width: 24px;
                max-height: 24px;
                object-fit: cover;
                -webkit-transition: filter 0.35s ease-in-out,
                  opacity 0.35s ease-in-out;
                -moz-transition: filter 0.35s ease-in-out,
                  opacity 0.35s ease-in-out;
                -ms-transition: filter 0.35s ease-in-out,
                  opacity 0.35s ease-in-out;
                -o-transition: filter 0.35s ease-in-out,
                  opacity 0.35s ease-in-out;
                transition: filter 0.35s ease-in-out, opacity 0.35s ease-in-out;
              }
            }

            &__text {
              filter: invert(0%);
              opacity: 0;
              pointer-events: none;
              position: absolute;
              left: 50px;
              background-color: black;
              color: white;
              font-size: 10px;
              line-height: 10px;
              padding: 4px 14px;
              white-space: nowrap;
              -webkit-transition: opacity 0.35s ease-in-out,
                filter 0.35s ease-in-out;
              -moz-transition: opacity 0.35s ease-in-out,
                filter 0.35s ease-in-out;
              -ms-transition: opacity 0.35s ease-in-out,
                filter 0.35s ease-in-out;
              -o-transition: opacity 0.35s ease-in-out, filter 0.35s ease-in-out;
              transition: opacity 0.35s ease-in-out, filter 0.35s ease-in-out;

              & p {
                opacity: 1;
                -webkit-transition: opacity 0.35s ease-in-out;
                -moz-transition: opacity 0.35s ease-in-out;
                -ms-transition: opacity 0.35s ease-in-out;
                -o-transition: opacity 0.35s ease-in-out;
                transition: opacity 0.35s ease-in-out;
              }
            }

            &:nth-child(1) {
              border-radius: 0px 5px 0px 0px;

              & .buttons__item__options__item {
                &__miniatura {
                  border-radius: 0px 5px 0px 0px;
                }
              }
            }

            &:nth-child(2) {
              border-radius: 0px 5px 0px 0px;

              & .buttons__item__options__item {
                &__miniatura {
                  border-radius: 0px 5px 0px 0px;
                }
              }
            }

            &:nth-child(3) {
              border-radius: 0px 0px 0px 0px;

              & .buttons__item__options__item {
                &__miniatura {
                  border-radius: 0px 0px 0px 0px;
                }
              }
            }

            &:nth-child(4) {
              border-radius: 0px 0px 5px 0px;

              & .buttons__item__options__item {
                &__miniatura {
                  border-radius: 0px 0px 5px 0px;
                }
              }
            }

            &:hover {
              & .buttons__item__options__item {
                &__text {
                  opacity: 1;
                  -webkit-transition: opacity 0.35s ease-in-out;
                  -moz-transition: opacity 0.35s ease-in-out;
                  -ms-transition: opacity 0.35s ease-in-out;
                  -o-transition: opacity 0.35s ease-in-out;
                  transition: opacity 0.35s ease-in-out;
                }
              }
            }
          }
        }

        &__miniatura {
          display: none;

          &__image {
            background-image: url("@/assets/Images/Global/Folder.svg");
            -webkit-transition: all 0.35s ease-in-out !important;
            -moz-transition: all 0.35s ease-in-out !important;
            -ms-transition: all 0.35s ease-in-out !important;
            -o-transition: all 0.35s ease-in-out !important;
            transition: all 0.35s ease-in-out !important;
          }
        }

        &__text {
          display: none;
        }
      }
    }
  }

  &.open {
    right: 350px;
    -webkit-transition: right 0.35s ease-in-out;
    -moz-transition: right 0.35s ease-in-out;
    -ms-transition: right 0.35s ease-in-out;
    -o-transition: right 0.35s ease-in-out;
    transition: right 0.35s ease-in-out;

    & .buttons {
      &__item {
        &:nth-child(10) {
          opacity: 1;
          pointer-events: visible;
          -webkit-transition: opacity 0.35s ease-in-out;
          -moz-transition: opacity 0.35s ease-in-out;
          -ms-transition: opacity 0.35s ease-in-out;
          -o-transition: opacity 0.35s ease-in-out;
          transition: opacity 0.35s ease-in-out;
        }
      }
    }
  }

  &.pano {
    & .buttons {
      &__item {
        &:nth-child(8) {
          border-radius: 0px 0px 0px 0px;

          & .buttons__item {
            &__miniatura {
              border-radius: 0px 0px 0px 0px;
            }
          }
        }

        &:nth-child(9) {
          opacity: 1;
          pointer-events: visible;
          width: revert;
          height: revert;
        }
      }
    }
  }

  @media screen and (max-width: 950px) and (min-height: 600px) {
    z-index: 10000;
    position: absolute;
    bottom: 100px;
    right: revert;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    align-content: center;
    width: 100%;
    height: 60px;
    right: 0px !important;
    -webkit-transition: bottom 0.35s ease-in-out, height 0.35s ease-in-out;
    -moz-transition: bottom 0.35s ease-in-out, height 0.35s ease-in-out;
    -ms-transition: bottom 0.35s ease-in-out, height 0.35s ease-in-out;
    -o-transition: bottom 0.35s ease-in-out, height 0.35s ease-in-out;
    transition: bottom 0.35s ease-in-out, height 0.35s ease-in-out;

    &__item {
      height: 60px;
      width: 100%;
      border-radius: 0px !important;
      background-color: white;
      -webkit-transition: background-color 0.35s ease-in-out,
        height 0.35s ease-in-out;
      -moz-transition: background-color 0.35s ease-in-out,
        height 0.35s ease-in-out;
      -ms-transition: background-color 0.35s ease-in-out,
        height 0.35s ease-in-out;
      -o-transition: background-color 0.35s ease-in-out,
        height 0.35s ease-in-out;
      transition: background-color 0.35s ease-in-out, height 0.35s ease-in-out;

      &__miniatura {
        border-radius: 0px !important;
      }

      &__text {
        display: none;
      }

      &.active {
        background-color: black;
        -webkit-transition: background-color 0.35s ease-in-out,
          height 0.35s ease-in-out;
        -moz-transition: background-color 0.35s ease-in-out,
          height 0.35s ease-in-out;
        -ms-transition: background-color 0.35s ease-in-out,
          height 0.35s ease-in-out;
        -o-transition: background-color 0.35s ease-in-out,
          height 0.35s ease-in-out;
        transition: background-color 0.35s ease-in-out, height 0.35s ease-in-out;
      }

      &:nth-child(1) {
        margin-bottom: revert;
        border-radius: 0px !important;

        & .buttons__item {
          &__miniatura {
            border-radius: 0px !important;
          }
        }
      }

      &:nth-child(2) {
        margin-bottom: revert;
        border-radius: 0px !important;

        & .buttons__item {
          &__miniatura {
            border-radius: 0px !important;
          }
        }
      }

      &:nth-child(3) {
        position: revert;
        border-radius: 0px !important;

        & .buttons__item {
          &__miniatura {
            border-radius: 0px !important;
          }
        }
      }

      &:nth-child(4) {
        border-radius: 0px !important;

        & .buttons__item {
          &__miniatura {
            border-radius: 0px !important;
          }
        }
      }

      &:nth-child(5) {
        border-radius: 0px !important;

        & .buttons__item {
          &__miniatura {
            border-radius: 0px !important;
          }
        }
      }

      &:nth-child(6) {
        margin-bottom: revert;
        border-radius: 0px !important;

        & .buttons__item {
          &__miniatura {
            border-radius: 0px !important;
          }
        }
      }

      &:nth-child(7) {
        border-radius: 0px !important;

        & .buttons__item {
          &__miniatura {
            border-radius: 0px !important;
          }
        }
      }

      &:nth-child(8) {
        border-radius: 0px !important;

        & .buttons__item {
          &__miniatura {
            border-radius: 0px !important;
          }
        }
      }

      &:nth-child(9) {
        margin-bottom: revert;
        border-radius: 0px !important;
        background-color: black;

        & .buttons__item {
          &__miniatura {
            border-radius: 0px !important;
          }
        }
      }

      &:nth-child(10) {
        display: none;
      }

      &.grupo {
        & .buttons__item {
          &__miniatura {
            opacity: 0;
            -webkit-transition: background-color 0.35s ease-in-out,
              opacity 0.35s ease-in-out;
            -moz-transition: background-color 0.35s ease-in-out,
              opacity 0.35s ease-in-out;
            -ms-transition: background-color 0.35s ease-in-out,
              opacity 0.35s ease-in-out;
            -o-transition: background-color 0.35s ease-in-out,
              opacity 0.35s ease-in-out;
            transition: background-color 0.35s ease-in-out,
              opacity 0.35s ease-in-out;
          }

          &__grupo {
            opacity: 1;
            -webkit-transition: opacity 0.35s ease-in-out;
            -moz-transition: opacity 0.35s ease-in-out;
            -ms-transition: opacity 0.35s ease-in-out;
            -o-transition: opacity 0.35s ease-in-out;
            transition: opacity 0.35s ease-in-out;
          }
        }
      }

      &.open {
        &.detalles {
          & .buttons__item {
            &__options {
              pointer-events: visible;
              opacity: 1;
              bottom: 60px;
              -webkit-transition: bottom 0.35s ease-in-out,
                opacity 0.35s ease-in-out !important;
              -moz-transition: bottom 0.35s ease-in-out,
                opacity 0.35s ease-in-out !important;
              -ms-transition: bottom 0.35s ease-in-out,
                opacity 0.35s ease-in-out !important;
              -o-transition: bottom 0.35s ease-in-out, opacity 0.35s ease-in-out !important;
              transition: bottom 0.35s ease-in-out, opacity 0.35s ease-in-out !important;

              &__item {
                &.disabled {
                  opacity: 0.25;
                  pointer-events: none;
                }

                &__text {
                  opacity: 1 !important;
                  left: calc((100dvw / 5) + 10px);
                }
              }
            }

            &__miniatura {
              &__image {}
            }

            &__text {}
          }
        }
      }

      &.detalles {
        & .buttons__item {
          &__options {
            pointer-events: none;
            z-index: 0;
            opacity: 0;
            left: 0px;
            bottom: calc(-60px * 3);
            -webkit-transition: bottom 0.35s ease-in-out,
              opacity 0.35s ease-in-out !important;
            -moz-transition: bottom 0.35s ease-in-out, opacity 0.35s ease-in-out !important;
            -ms-transition: bottom 0.35s ease-in-out, opacity 0.35s ease-in-out !important;
            -o-transition: bottom 0.35s ease-in-out, opacity 0.35s ease-in-out !important;
            transition: bottom 0.35s ease-in-out, opacity 0.35s ease-in-out !important;

            &__item {
              &.disabled {
                opacity: 0.25;
                pointer-events: none;
              }

              &__miniatura {
                width: calc(100dvw / 5);
                height: 60px;
                -webkit-transition: height 0.35s ease-in-out,
                  0.35s ease-in-out background-color;
                -moz-transition: height 0.35s ease-in-out,
                  0.35s ease-in-out background-color;
                -ms-transition: height 0.35s ease-in-out,
                  0.35s ease-in-out background-color;
                -o-transition: height 0.35s ease-in-out,
                  0.35s ease-in-out background-color;
                transition: height 0.35s ease-in-out,
                  0.35s ease-in-out background-color;
              }

              &:nth-child(4) {
                & .buttons__item__options__item {
                  &__miniatura {
                    border-radius: 0px !important;
                    -webkit-transition: height 0.35s ease-in-out,
                      0.35s ease-in-out background-color;
                    -moz-transition: height 0.35s ease-in-out,
                      0.35s ease-in-out background-color;
                    -ms-transition: height 0.35s ease-in-out,
                      0.35s ease-in-out background-color;
                    -o-transition: height 0.35s ease-in-out,
                      0.35s ease-in-out background-color;
                    transition: height 0.35s ease-in-out,
                      0.35s ease-in-out background-color;
                  }
                }
              }

              &__text {
                opacity: 1 !important;
                left: calc((100dvw / 5) + 10px);
              }
            }
          }

          &__miniatura {
            display: block;
          }
        }
      }
    }

    &.open {
      height: 40px;
      bottom: calc(55dvh + 40px);
      -webkit-transition: bottom 0.35s ease-in-out, height 0.35s ease-in-out;
      -moz-transition: bottom 0.35s ease-in-out, height 0.35s ease-in-out;
      -ms-transition: bottom 0.35s ease-in-out, height 0.35s ease-in-out;
      -o-transition: bottom 0.35s ease-in-out, height 0.35s ease-in-out;
      transition: bottom 0.35s ease-in-out, height 0.35s ease-in-out;

      & .buttons {
        &__item {
          height: 40px;
          -webkit-transition: background-color 0.35s ease-in-out,
            height 0.35s ease-in-out;
          -moz-transition: background-color 0.35s ease-in-out,
            height 0.35s ease-in-out;
          -ms-transition: background-color 0.35s ease-in-out,
            height 0.35s ease-in-out;
          -o-transition: background-color 0.35s ease-in-out,
            height 0.35s ease-in-out;
          transition: background-color 0.35s ease-in-out,
            height 0.35s ease-in-out;

          &.open {
            &.detalles {
              & .buttons__item {
                &__options {
                  opacity: 1;
                  bottom: 40px;
                  -webkit-transition: bottom 0.35s ease-in-out,
                    opacity 0.35s ease-in-out !important;
                  -moz-transition: bottom 0.35s ease-in-out,
                    opacity 0.35s ease-in-out !important;
                  -ms-transition: bottom 0.35s ease-in-out,
                    opacity 0.35s ease-in-out !important;
                  -o-transition: bottom 0.35s ease-in-out,
                    opacity 0.35s ease-in-out !important;
                  transition: bottom 0.35s ease-in-out,
                    opacity 0.35s ease-in-out !important;

                  &__item {
                    &.disabled {
                      opacity: 0.25;
                      pointer-events: none;
                    }

                    &__text {
                      opacity: 1 !important;
                      left: calc((100dvw / 5) + 10px);
                    }
                  }
                }

                &__miniatura {
                  &__image {}
                }

                &__text {}
              }
            }
          }

          &.detalles {
            & .buttons__item {
              &__options {
                z-index: 0;
                opacity: 0;
                left: 0px;
                bottom: calc(-40px * 3);
                -webkit-transition: bottom 0.35s ease-in-out,
                  opacity 0.35s ease-in-out !important;
                -moz-transition: bottom 0.35s ease-in-out,
                  opacity 0.35s ease-in-out !important;
                -ms-transition: bottom 0.35s ease-in-out,
                  opacity 0.35s ease-in-out !important;
                -o-transition: bottom 0.35s ease-in-out,
                  opacity 0.35s ease-in-out !important;
                transition: bottom 0.35s ease-in-out, opacity 0.35s ease-in-out !important;

                &__item {
                  &.disabled {
                    opacity: 0.25;
                    pointer-events: none;
                  }

                  &__miniatura {
                    width: calc(100dvw / 5);
                    height: 40px;
                    -webkit-transition: height 0.35s ease-in-out;
                    -moz-transition: height 0.35s ease-in-out;
                    -ms-transition: height 0.35s ease-in-out;
                    -o-transition: height 0.35s ease-in-out;
                    transition: height 0.35s ease-in-out;
                  }

                  &:nth-child(4) {
                    & .buttons__item__options__item {
                      &__miniatura {
                        border-radius: 0px !important;
                      }
                    }
                  }

                  &__text {
                    opacity: 1 !important;
                    left: calc((100dvw / 5) + 10px);
                  }
                }
              }
            }
          }
        }
      }

      &.pano {
        & .buttons__item {
          &.open {
            &.detalles {
              & .buttons__item {
                &__options {
                  opacity: 1;
                  bottom: 40px;
                  -webkit-transition: bottom 0.35s ease-in-out,
                    opacity 0.35s ease-in-out !important;
                  -moz-transition: bottom 0.35s ease-in-out,
                    opacity 0.35s ease-in-out !important;
                  -ms-transition: bottom 0.35s ease-in-out,
                    opacity 0.35s ease-in-out !important;
                  -o-transition: bottom 0.35s ease-in-out,
                    opacity 0.35s ease-in-out !important;
                  transition: bottom 0.35s ease-in-out,
                    opacity 0.35s ease-in-out !important;

                  &__item {
                    &.disabled {
                      opacity: 0.25;
                      pointer-events: none;
                    }

                    &__text {
                      opacity: 1 !important;
                      left: calc((100dvw / 6) + 10px);
                    }
                  }
                }

                &__miniatura {
                  &__image {}
                }

                &__text {}
              }
            }
          }

          &.detalles {
            & .buttons__item {
              &__options {
                z-index: 0;
                opacity: 0;
                left: 0px;
                bottom: calc(-40px * 3);
                -webkit-transition: bottom 0.35s ease-in-out,
                  opacity 0.35s ease-in-out !important;
                -moz-transition: bottom 0.35s ease-in-out,
                  opacity 0.35s ease-in-out !important;
                -ms-transition: bottom 0.35s ease-in-out,
                  opacity 0.35s ease-in-out !important;
                -o-transition: bottom 0.35s ease-in-out,
                  opacity 0.35s ease-in-out !important;
                transition: bottom 0.35s ease-in-out, opacity 0.35s ease-in-out !important;

                &__item {
                  &.disabled {
                    opacity: 0.25;
                    pointer-events: none;
                  }

                  &__miniatura {
                    width: calc(100dvw / 6);
                    height: 40px;
                  }

                  &:nth-child(4) {
                    & .buttons__item__options__item {
                      &__miniatura {
                        border-radius: 0px !important;
                      }
                    }
                  }

                  &__text {
                    opacity: 1 !important;
                    left: calc((100dvw / 6) + 10px);
                  }
                }
              }
            }
          }
        }
      }
    }

    &.bottom {
      bottom: 0px;
      -webkit-transition: bottom 0.35s ease-in-out, height 0.35s ease-in-out;
      -moz-transition: bottom 0.35s ease-in-out, height 0.35s ease-in-out;
      -ms-transition: bottom 0.35s ease-in-out, height 0.35s ease-in-out;
      -o-transition: bottom 0.35s ease-in-out, height 0.35s ease-in-out;
      transition: bottom 0.35s ease-in-out, height 0.35s ease-in-out;
    }

    &.pano {
      & .buttons {
        &__item {
          &:nth-child(9) {
            width: 100%;
            height: 100%;
          }

          &.detalles {
            & .buttons__item {
              &__options {
                &__item {
                  &.disabled {
                    opacity: 0.25;
                    pointer-events: none;
                  }

                  &__miniatura {
                    width: calc(100dvw / 6);
                    -webkit-transition: height 0.35s ease-in-out,
                      0.35s ease-in-out background-color;
                    -moz-transition: height 0.35s ease-in-out,
                      0.35s ease-in-out background-color;
                    -ms-transition: height 0.35s ease-in-out,
                      0.35s ease-in-out background-color;
                    -o-transition: height 0.35s ease-in-out,
                      0.35s ease-in-out background-color;
                    transition: height 0.35s ease-in-out,
                      0.35s ease-in-out background-color;
                  }

                  &__text {
                    opacity: 1 !important;
                    left: calc((100dvw / 6) + 10px);
                    -webkit-transition: all 0.35s ease-in-out;
                    -moz-transition: all 0.35s ease-in-out;
                    -ms-transition: all 0.35s ease-in-out;
                    -o-transition: all 0.35s ease-in-out;
                    transition: all 0.35s ease-in-out;
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  @media screen and (max-height: 600px) {
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    top: $Header-height;
    height: calc(100% - $Header-height);
    width: 100px;
    -webkit-transition: right 0.35s ease-in-out, width 0.35s ease-in-out;
    -moz-transition: right 0.35s ease-in-out, width 0.35s ease-in-out;
    -ms-transition: right 0.35s ease-in-out, width 0.35s ease-in-out;
    -o-transition: right 0.35s ease-in-out, width 0.35s ease-in-out;
    transition: right 0.35s ease-in-out, width 0.35s ease-in-out;

    &__item {
      height: 100%;
      width: 100px;
      background-color: white;
      -webkit-transition: background-color 0.35s ease-in-out,
        width 0.35s ease-in-out;
      -moz-transition: background-color 0.35s ease-in-out,
        width 0.35s ease-in-out;
      -ms-transition: background-color 0.35s ease-in-out,
        width 0.35s ease-in-out;
      -o-transition: background-color 0.35s ease-in-out, width 0.35s ease-in-out;
      transition: background-color 0.35s ease-in-out, width 0.35s ease-in-out;

      &.active {
        background-color: black;
        -webkit-transition: background-color 0.35s ease-in-out,
          width 0.35s ease-in-out;
        -moz-transition: background-color 0.35s ease-in-out,
          width 0.35s ease-in-out;
        -ms-transition: background-color 0.35s ease-in-out,
          width 0.35s ease-in-out;
        -o-transition: background-color 0.35s ease-in-out,
          width 0.35s ease-in-out;
        transition: background-color 0.35s ease-in-out, width 0.35s ease-in-out;
      }

      &__text {
        display: none;
      }

      &__grupo {
        transform: rotate(270deg);
      }

      &:nth-child(1) {
        margin-bottom: revert;
        border-radius: 0px !important;

        & .buttons__item {
          &__miniatura {
            border-radius: 0px !important;
          }
        }
      }

      &:nth-child(2) {
        margin-bottom: revert;
        border-radius: 0px !important;

        & .buttons__item {
          &__miniatura {
            border-radius: 0px !important;
          }
        }
      }

      &:nth-child(3) {
        position: revert;
        border-radius: 0px !important;

        & .buttons__item {
          &__miniatura {
            border-radius: 0px !important;
          }
        }
      }

      &:nth-child(4) {
        border-radius: 0px !important;

        & .buttons__item {
          &__miniatura {
            border-radius: 0px !important;
          }
        }
      }

      &:nth-child(5) {
        border-radius: 0px !important;

        & .buttons__item {
          &__miniatura {
            border-radius: 0px !important;
          }
        }
      }

      &:nth-child(6) {
        margin-bottom: revert;
        border-radius: 0px !important;

        & .buttons__item {
          &__miniatura {
            border-radius: 0px !important;
          }
        }
      }

      &:nth-child(7) {
        border-radius: 0px !important;

        & .buttons__item {
          &__miniatura {
            border-radius: 0px !important;
          }
        }
      }

      &:nth-child(8) {
        border-radius: 0px !important;

        & .buttons__item {
          &__miniatura {
            border-radius: 0px !important;
          }
        }
      }

      &:nth-child(9) {
        margin-bottom: revert;
        border-radius: 0px !important;
        background-color: black;

        & .buttons__item {
          &__miniatura {
            border-radius: 0px !important;
          }
        }
      }

      &:nth-child(10) {
        opacity: 0;
        pointer-events: none;
        border-radius: 0px !important;
        height: 0px;
        width: 0px;
        -webkit-transition: all 0.35s ease-in-out;
        -moz-transition: all 0.35s ease-in-out;
        -ms-transition: all 0.35s ease-in-out;
        -o-transition: all 0.35s ease-in-out;
        transition: all 0.35s ease-in-out;

        & .buttons__item {
          &__miniatura {
            border-radius: 0px !important;
          }
        }
      }

      &.grupo {
        & .buttons__item {
          &__miniatura {
            opacity: 0;
            -webkit-transition: background-color 0.35s ease-in-out,
              opacity 0.35s ease-in-out;
            -moz-transition: background-color 0.35s ease-in-out,
              opacity 0.35s ease-in-out;
            -ms-transition: background-color 0.35s ease-in-out,
              opacity 0.35s ease-in-out;
            -o-transition: background-color 0.35s ease-in-out,
              opacity 0.35s ease-in-out;
            transition: background-color 0.35s ease-in-out,
              opacity 0.35s ease-in-out;
          }

          &__grupo {
            opacity: 1;
            -webkit-transition: opacity 0.35s ease-in-out;
            -moz-transition: opacity 0.35s ease-in-out;
            -ms-transition: opacity 0.35s ease-in-out;
            -o-transition: opacity 0.35s ease-in-out;
            transition: opacity 0.35s ease-in-out;
          }
        }
      }

      &.open {
        &.detalles {
          & .buttons__item {
            &__options {
              pointer-events: visible;
              opacity: 1;
              right: 100px;
              -webkit-transition: right 0.35s ease-in-out,
                opacity 0.35s ease-in-out, height 0.35s ease-in-out !important;
              -moz-transition: right 0.35s ease-in-out,
                opacity 0.35s ease-in-out, height 0.35s ease-in-out !important;
              -ms-transition: right 0.35s ease-in-out, opacity 0.35s ease-in-out,
                height 0.35s ease-in-out !important;
              -o-transition: right 0.35s ease-in-out, opacity 0.35s ease-in-out,
                height 0.35s ease-in-out !important;
              transition: right 0.35s ease-in-out, opacity 0.35s ease-in-out,
                height 0.35s ease-in-out !important;

              &__item {
                &.disabled {
                  opacity: 0.25;
                  pointer-events: none;
                }

                &__text {
                  //
                  color: white;
                  background-color: black;
                  opacity: 1 !important;
                  position: revert;
                  -webkit-transition: all 0.35s ease-in-out;
                  -moz-transition: all 0.35s ease-in-out;
                  -ms-transition: all 0.35s ease-in-out;
                  -o-transition: all 0.35s ease-in-out;
                  transition: all 0.35s ease-in-out;
                }
              }
            }
          }
        }
      }

      &.detalles {
        & .buttons__item {
          &__options {
            pointer-events: none;
            z-index: 0;
            opacity: 0;
            display: flex;
            flex-direction: row;
            top: 0;
            height: calc((100dvh - $Header-height) / 5);
            right: calc(-100px * 3);
            left: revert !important;
            -webkit-transition: right 0.35s ease-in-out,
              opacity 0.35s ease-in-out, height 0.35s ease-in-out !important;
            -moz-transition: right 0.35s ease-in-out, opacity 0.35s ease-in-out,
              height 0.35s ease-in-out !important;
            -ms-transition: right 0.35s ease-in-out, opacity 0.35s ease-in-out,
              height 0.35s ease-in-out !important;
            -o-transition: right 0.35s ease-in-out, opacity 0.35s ease-in-out,
              height 0.35s ease-in-out !important;
            transition: right 0.35s ease-in-out, opacity 0.35s ease-in-out,
              height 0.35s ease-in-out !important;

            &__item {
              &.disabled {
                opacity: 0.25;
                pointer-events: none;
              }

              display: flex;
              flex-direction: column;
              justify-content: flex-end;
              border-radius: 0px !important;
              background-color: white;
              -webkit-transition: background-color 0.35s ease-in-out;
              -moz-transition: background-color 0.35s ease-in-out;
              -ms-transition: background-color 0.35s ease-in-out;
              -o-transition: background-color 0.35s ease-in-out;
              transition: background-color 0.35s ease-in-out;

              &__miniatura {
                width: 100px;
                height: calc((100dvh - $Header-height) / 5);
                border-radius: 0px !important;
                padding: 0px !important;
                -webkit-transition: width 0.35s ease-in-out,
                  height 0.35s ease-in-out, background-color 0.35s ease-in-out;
                -moz-transition: width 0.35s ease-in-out,
                  height 0.35s ease-in-out, background-color 0.35s ease-in-out;
                -ms-transition: width 0.35s ease-in-out,
                  height 0.35s ease-in-out, background-color 0.35s ease-in-out;
                -o-transition: width 0.35s ease-in-out, height 0.35s ease-in-out,
                  background-color 0.35s ease-in-out;
                transition: width 0.35s ease-in-out, height 0.35s ease-in-out,
                  background-color 0.35s ease-in-out;
              }

              &__text {
                //
                color: white;
                background-color: black;
                opacity: 1 !important;
                position: revert;
                -webkit-transition: all 0.35s ease-in-out;
                -moz-transition: all 0.35s ease-in-out;
                -ms-transition: all 0.35s ease-in-out;
                -o-transition: all 0.35s ease-in-out;
                transition: all 0.35s ease-in-out;
              }
            }
          }

          &__miniatura {
            display: block;
          }
        }
      }
    }

    &.open {
      width: 40px;
      right: 247px;
      -webkit-transition: right 0.35s ease-in-out, width 0.35s ease-in-out;
      -moz-transition: right 0.35s ease-in-out, width 0.35s ease-in-out;
      -ms-transition: right 0.35s ease-in-out, width 0.35s ease-in-out;
      -o-transition: right 0.35s ease-in-out, width 0.35s ease-in-out;
      transition: right 0.35s ease-in-out, width 0.35s ease-in-out;

      & .buttons {
        &__item {
          width: 40px;
          -webkit-transition: background-color 0.35s ease-in-out,
            width 0.35s ease-in-out;
          -moz-transition: background-color 0.35s ease-in-out,
            width 0.35s ease-in-out;
          -ms-transition: background-color 0.35s ease-in-out,
            width 0.35s ease-in-out;
          -o-transition: background-color 0.35s ease-in-out,
            width 0.35s ease-in-out;
          transition: background-color 0.35s ease-in-out,
            width 0.35s ease-in-out;

          &:nth-child(10) {
            width: 100%;
            height: 100%;
            -webkit-transition: all 0.35s ease-in-out;
            -moz-transition: all 0.35s ease-in-out;
            -ms-transition: all 0.35s ease-in-out;
            -o-transition: all 0.35s ease-in-out;
            transition: all 0.35s ease-in-out;
          }

          &.open {
            &.detalles {
              & .buttons__item {
                &__options {
                  opacity: 1;
                  right: 40px;
                  -webkit-transition: right 0.35s ease-in-out,
                    opacity 0.35s ease-in-out, height 0.35s ease-in-out !important;
                  -moz-transition: right 0.35s ease-in-out,
                    opacity 0.35s ease-in-out, height 0.35s ease-in-out !important;
                  -ms-transition: right 0.35s ease-in-out,
                    opacity 0.35s ease-in-out, height 0.35s ease-in-out !important;
                  -o-transition: right 0.35s ease-in-out,
                    opacity 0.35s ease-in-out, height 0.35s ease-in-out !important;
                  transition: right 0.35s ease-in-out, opacity 0.35s ease-in-out,
                    height 0.35s ease-in-out !important;

                  &__item {
                    &.disabled {
                      opacity: 0.25;
                      pointer-events: none;
                    }

                    &__miniatura {
                      width: 40px;
                      -webkit-transition: width 0.35s ease-in-out,
                        height 0.35s ease-in-out,
                        background-color 0.35s ease-in-out;
                      -moz-transition: width 0.35s ease-in-out,
                        height 0.35s ease-in-out,
                        background-color 0.35s ease-in-out;
                      -ms-transition: width 0.35s ease-in-out,
                        height 0.35s ease-in-out,
                        background-color 0.35s ease-in-out;
                      -o-transition: width 0.35s ease-in-out,
                        height 0.35s ease-in-out,
                        background-color 0.35s ease-in-out;
                      transition: width 0.35s ease-in-out,
                        height 0.35s ease-in-out,
                        background-color 0.35s ease-in-out;
                    }

                    &__text {
                      //
                      color: white;
                      background-color: black;
                      opacity: 1 !important;
                      position: revert;
                      -webkit-transition: all 0.35s ease-in-out;
                      -moz-transition: all 0.35s ease-in-out;
                      -ms-transition: all 0.35s ease-in-out;
                      -o-transition: all 0.35s ease-in-out;
                      transition: all 0.35s ease-in-out;
                    }
                  }
                }
              }
            }
          }

          &.detalles {
            & .buttons__item {
              &__options {
                height: calc((100dvh - $Header-height) / 6) !important;
                -webkit-transition: right 0.35s ease-in-out,
                  opacity 0.35s ease-in-out, height 0.35s ease-in-out !important;
                -moz-transition: right 0.35s ease-in-out,
                  opacity 0.35s ease-in-out, height 0.35s ease-in-out !important;
                -ms-transition: right 0.35s ease-in-out,
                  opacity 0.35s ease-in-out, height 0.35s ease-in-out !important;
                -o-transition: right 0.35s ease-in-out,
                  opacity 0.35s ease-in-out, height 0.35s ease-in-out !important;
                transition: right 0.35s ease-in-out, opacity 0.35s ease-in-out,
                  height 0.35s ease-in-out !important;

                &__item {
                  &.disabled {
                    opacity: 0.25;
                    pointer-events: none;
                  }

                  &__miniatura {
                    height: calc((100dvh - $Header-height) / 6) !important;
                    -webkit-transition: width 0.35s ease-in-out,
                      height 0.35s ease-in-out,
                      background-color 0.35s ease-in-out;
                    -moz-transition: width 0.35s ease-in-out,
                      height 0.35s ease-in-out,
                      background-color 0.35s ease-in-out;
                    -ms-transition: width 0.35s ease-in-out,
                      height 0.35s ease-in-out,
                      background-color 0.35s ease-in-out;
                    -o-transition: width 0.35s ease-in-out,
                      height 0.35s ease-in-out,
                      background-color 0.35s ease-in-out;
                    transition: width 0.35s ease-in-out,
                      height 0.35s ease-in-out,
                      background-color 0.35s ease-in-out;
                  }

                  &__text {
                    //
                    color: white;
                    background-color: black;
                    opacity: 1 !important;
                    position: revert;
                    -webkit-transition: all 0.35s ease-in-out;
                    -moz-transition: all 0.35s ease-in-out;
                    -ms-transition: all 0.35s ease-in-out;
                    -o-transition: all 0.35s ease-in-out;
                    transition: all 0.35s ease-in-out;
                  }
                }
              }
            }
          }
        }
      }
    }

    &.pano {
      & .buttons {
        &__item {
          &:nth-child(9) {
            height: 100%;
            width: 100%;
          }

          &.detalles {
            & .buttons__item {
              &__options {
                height: calc((100dvh - $Header-height) / 6) !important;
                -webkit-transition: right 0.35s ease-in-out,
                  opacity 0.35s ease-in-out, height 0.35s ease-in-out !important;
                -moz-transition: right 0.35s ease-in-out,
                  opacity 0.35s ease-in-out, height 0.35s ease-in-out !important;
                -ms-transition: right 0.35s ease-in-out,
                  opacity 0.35s ease-in-out, height 0.35s ease-in-out !important;
                -o-transition: right 0.35s ease-in-out,
                  opacity 0.35s ease-in-out, height 0.35s ease-in-out !important;
                transition: right 0.35s ease-in-out, opacity 0.35s ease-in-out,
                  height 0.35s ease-in-out !important;

                &__item {
                  &.disabled {
                    opacity: 0.25;
                    pointer-events: none;
                  }

                  &__miniatura {
                    height: calc((100dvh - $Header-height) / 6) !important;
                    -webkit-transition: width 0.35s ease-in-out,
                      height 0.35s ease-in-out,
                      background-color 0.35s ease-in-out;
                    -moz-transition: width 0.35s ease-in-out,
                      height 0.35s ease-in-out,
                      background-color 0.35s ease-in-out;
                    -ms-transition: width 0.35s ease-in-out,
                      height 0.35s ease-in-out,
                      background-color 0.35s ease-in-out;
                    -o-transition: width 0.35s ease-in-out,
                      height 0.35s ease-in-out,
                      background-color 0.35s ease-in-out;
                    transition: width 0.35s ease-in-out,
                      height 0.35s ease-in-out,
                      background-color 0.35s ease-in-out;
                  }

                  &__text {
                    //
                    color: white;
                    background-color: black;
                    opacity: 1 !important;
                    position: revert;
                    -webkit-transition: all 0.35s ease-in-out;
                    -moz-transition: all 0.35s ease-in-out;
                    -ms-transition: all 0.35s ease-in-out;
                    -o-transition: all 0.35s ease-in-out;
                    transition: all 0.35s ease-in-out;
                  }
                }
              }
            }
          }
        }
      }

      &.open {
        & .buttons {
          &__item {
            &.detalles {
              & .buttons__item {
                &__options {
                  height: calc((100dvh - $Header-height) / 7) !important;
                  -webkit-transition: right 0.35s ease-in-out,
                    opacity 0.35s ease-in-out, height 0.35s ease-in-out !important;
                  -moz-transition: right 0.35s ease-in-out,
                    opacity 0.35s ease-in-out, height 0.35s ease-in-out !important;
                  -ms-transition: right 0.35s ease-in-out,
                    opacity 0.35s ease-in-out, height 0.35s ease-in-out !important;
                  -o-transition: right 0.35s ease-in-out,
                    opacity 0.35s ease-in-out, height 0.35s ease-in-out !important;
                  transition: right 0.35s ease-in-out, opacity 0.35s ease-in-out,
                    height 0.35s ease-in-out !important;

                  &__item {
                    &.disabled {
                      opacity: 0.25;
                      pointer-events: none;
                    }

                    &__miniatura {
                      height: calc((100dvh - $Header-height) / 7) !important;
                      -webkit-transition: width 0.35s ease-in-out,
                        height 0.35s ease-in-out,
                        background-color 0.35s ease-in-out;
                      -moz-transition: width 0.35s ease-in-out,
                        height 0.35s ease-in-out,
                        background-color 0.35s ease-in-out;
                      -ms-transition: width 0.35s ease-in-out,
                        height 0.35s ease-in-out,
                        background-color 0.35s ease-in-out;
                      -o-transition: width 0.35s ease-in-out,
                        height 0.35s ease-in-out,
                        background-color 0.35s ease-in-out;
                      transition: width 0.35s ease-in-out,
                        height 0.35s ease-in-out,
                        background-color 0.35s ease-in-out;
                    }

                    &__text {
                      //
                      color: white;
                      background-color: black;
                      opacity: 1 !important;
                      position: revert;
                      -webkit-transition: all 0.35s ease-in-out;
                      -moz-transition: all 0.35s ease-in-out;
                      -ms-transition: all 0.35s ease-in-out;
                      -o-transition: all 0.35s ease-in-out;
                      transition: all 0.35s ease-in-out;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

//HARDCODE - FAVORITES HIDDEN
.buttons__item {
  &:nth-child(5) {
    border-radius: 0px 0px 0px 5px;

    & .buttons__item {
      &__miniatura {
        border-radius: 0px 0px 0px 5px;
      }
    }
  }

  &:nth-child(6) {
    width: 0px;
    height: 0px;
    opacity: 0;
    pointer-events: none;
  }
}

.hidden {
  opacity: 0 !important;
  -webkit-transition: filter 0.35s ease-in-out, opacity 0.35s ease-in-out;
  -moz-transition: filter 0.35s ease-in-out, opacity 0.35s ease-in-out;
  -ms-transition: filter 0.35s ease-in-out, opacity 0.35s ease-in-out;
  -o-transition: filter 0.35s ease-in-out, opacity 0.35s ease-in-out;
  transition: filter 0.35s ease-in-out, opacity 0.35s ease-in-out;
}
</style>
